import {post, get} from '@/utils/request'

// 获取会员树 
export function getMemberTreeReq(data) {
    return post({
        data,
        url: 'member/userManage/memberTreeList'
    })
}

// 人员管理-表格数据(人员列表)
export function getPersonnelListReq(data) {
    return post({
        data,
        url: 'member/userManage/userList'
    })
}

// 启用、禁用人员状态（人员状态开关变化）（启用禁用用户状态）
export function statusChangeReq(data) {
    return post({
        data,
        url: 'member/userManage/updateUserStatus'
    })
}

// 删除人员
// export function delPersonnelReq(data) {
//     return post({
//         data,
//         url: '!'
//     })
// }


// 添加人员(添加用户)
export function addPersonnelReq(data) {
    return post({
        data,
        url: 'member/userManage/addUser'
    })
}

// 修改用户信息？编辑人员(修改用户信息)
export function editPersonnelReq(data) {
    return post({
        data,
        url: 'member/userManage/editUser'
    })
}

// 根据用户id获取用户信息
export function getPersonnelDetailReq(data) {
    return post({
        data,
        url: 'member/userManage/getUserById'
    })
}

// 根据用户返回角色（用户拥有的角色会有标识）
// ps:id传空会返回所有角色||通过当前ID获取当前人员已选的角色
export function getPersonnelRoleReq(params) {
    return get({
        params: params,
        // url: 'member/userManage/getRoleByUser'
        url: 'member/roles'
    })
}

// 人员密码重置
export function resetPasswordReq(data) {
    return post({
        data,
        url: 'member/userManage/resetPassword'
    })
}

// 返回所有会员信息
export function getAllMemberReq(data) {
    return post({
        data,
        url: 'member/userManage/getAllMember'
    })
}


// 返回用户的角色
export function getUserRoles(userId) {
    return get({
        url: `member/users/${userId}/roles`
    })
}
